import { render, staticRenderFns } from "./group-detail.vue?vue&type=template&id=2a8bf8f0&scoped=true"
import script from "./group-detail.vue?vue&type=script&lang=js"
export * from "./group-detail.vue?vue&type=script&lang=js"
import style0 from "./group-detail.vue?vue&type=style&index=0&id=2a8bf8f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8bf8f0",
  null
  
)

export default component.exports